/* eslint-disable @angular-eslint/component-selector */
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ClientConsultNoteTask } from '../../../core/models/client-consult-note-task.model';
import { RouterLink } from '@angular/router';
import { UserPresenceComponent } from '../../../shared/components/user-presence/user-presence.component';
import { PrescriberNameComponent } from '../../../shared/components/prescriber-name/prescriber-name.component';
import { TaskEstimatedValueComponent } from '../../../shared/components/task-estimated-value/task-estimated-value.component';
import { ExpirationDateComponent } from '../../../shared/components/expiration-date/expiration-date.component';
import { DecimalPipe, DatePipe } from '@angular/common';
import { TaskStatusPipe } from '../../../shared/pipes/task-status.pipe';
import { ClaimSourcePipe } from '../../../shared/pipes/claim-source.pipe';
import { BlankValueDashPipe } from '../../../shared/pipes/blank-value-dash.pipe';

@Component({
    selector: '[app-consult-note-task-list-row]',
    templateUrl: './consult-note-task-list-row.component.html',
    styleUrls: ['./consult-note-task-list-row.component.scss'],
    imports: [RouterLink,
              UserPresenceComponent,
              PrescriberNameComponent,
              TaskEstimatedValueComponent,
              ExpirationDateComponent,
              DecimalPipe,
              DatePipe,
              TaskStatusPipe,
              ClaimSourcePipe,
              BlankValueDashPipe]
})
export class ConsultNoteTaskListRowComponent {
  @Input() task: ClientConsultNoteTask;
  @Input() position: number;

  @Output() viewTask = new EventEmitter<number>();

  constructor() {}


  onViewClick() {
    this.viewTask.emit(this.position);
  }
}
